<template>
  <div class="h-px w-full shrink-0 grow-0" :class="schemeClass"></div>
</template>
<script setup lang="ts">
import { computed, PropType } from 'vue';

import { MenuScheme } from '../types';

const props = defineProps({
  scheme: {
    type: String as PropType<MenuScheme>,
    default: 'default',
  },
});

const schemeClasses: Record<MenuScheme, string> = {
  default: 'bg-grey-25',
  dark: 'bg-grey-600',
  custom: '',
};

const schemeClass = computed(() => schemeClasses[props.scheme]);
</script>
